import Header from "./Header";
import Footer from "./Footer";
import React, { useEffect, useState } from "react";
import axios from "axios";

const AutoPark = () => {
    const [cars, setCars] = useState([]);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        axios.get("https://kyrgyz-adventure-travel.com/api/v1/tours/cars")
            .then(response => {
                if (response.data.results.length > 0) {
                    setCars(response.data.results);
                }
            })
            .catch(error => console.error("Error loading data: ", error));
    }, []);

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="bg-dark min-h-screen">
            <Header isScrolled={isScrolled} />
            {/* Spacer to clear fixed header */}
            <div className="h-32" />

            <div className="container pb-20">
                <div className="flex flex-col items-center gap-4 mb-16">
                    <p className="font-unbounded text-gold text-xs uppercase tracking-widest">
                        Vehicle rental
                    </p>
                    <h1 className="font-unbounded font-bold text-4xl md:text-5xl text-white text-center">
                        Car Rental
                    </h1>
                    <p className="font-manrope text-white/60 text-lg text-center max-w-xl mt-2">
                        Choose the perfect vehicle for your adventure in Central Asia
                    </p>
                </div>

                <div className="flex flex-wrap justify-center gap-8">
                    {cars.map((car) => (
                        <div key={car.id} className="card-dark w-full md:w-[calc(50%-16px)] group overflow-hidden">
                            <div className="relative overflow-hidden">
                                <img
                                    src={car.image}
                                    className="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-105"
                                    alt={car.brand}
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-dark-card via-transparent to-transparent" />
                                <div className="absolute top-5 left-5">
                                    <span className="font-unbounded font-bold text-lg text-white">{car.brand}</span>
                                </div>
                            </div>
                            <div className="p-6">
                                <div className="grid grid-cols-2 gap-3">
                                    {[
                                        { label: 'Engine', value: `${car.engine_volume} L` },
                                        { label: 'Seats', value: `${car.seats} people` },
                                        { label: 'Year', value: car.year },
                                        { label: 'Price/day', value: car.price_per_day },
                                    ].map(item => (
                                        <div key={item.label} className="bg-dark rounded-2xl p-4">
                                            <p className="font-manrope text-white/40 text-xs mb-1">{item.label}</p>
                                            <p className="font-unbounded font-semibold text-sm text-white">{item.value}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default AutoPark;
